<kilowant-header [isHome]="true" [isIndex]="true" linkHome="" [showClose]="showVideo()" (returned)="returnedFromHeader()"></kilowant-header>
<div class="wrapper-main-public-area home-page">
    <div class="home-video" [style.display]="(showVideo())?'block':'none'">
        <video controls style="width:100%" (ended)="hideVideo()" #video>
            <source src="video/kilowant-storyboard-v15.webm" type="video/webm">
            <source src="video/kilowant-storyboard-v15.ogv" type="video/ogg">
            <source src="video/kilowant-storyboard-v15.mp4" type="video/mp4">
        </video>
    </div>
    <div class="home-inner" style="margin-top: 30px;" [style.display]="(showVideo())?'none':'block'">
        <div class="how-it-works">
            @if (faq().length>0) {
            <div class="link">
                <a class="big" (click)="startVideo();">{{faq()[0].question}}</a>
                <a (click)="iIconPopup(getFirstFAQ());">Read more</a>
            </div>
            }
            <button class="start-video highlighted-button grey-highlight" (click)="startVideo();" title="Play the video that explains how Kilowant works."><svg fill="#58504e" style="margin-left: 5px;" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="30px" viewBox="0 0 96.155 96.155" xml:space="preserve" stroke="#58504e"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M20.972,95.594l57.605-45.951c0.951-0.76,0.951-2.367,0-3.127L20.968,0.56c-0.689-0.547-1.716-0.709-2.61-0.414 c-0.186,0.061-0.33,0.129-0.436,0.186c-0.65,0.35-1.056,1.025-1.056,1.764v91.967c0,0.736,0.405,1.414,1.056,1.762 c0.109,0.06,0.253,0.127,0.426,0.185C19.251,96.305,20.281,96.144,20.972,95.594z"></path> </g> </g></svg></button>
        </div>

        <div class="sphere-area">
            <div class="system">
                <div class="circle"></div>
                <div class="orbit a"><div class="dot"></div></div>
                <div class="orbit b"><div class="dot"></div></div>
                <div class="orbit c"><div class="dot"></div></div>
            </div>
            <div class="circle-inner-area">
                <h1><span class="text-nowrap">Nonstop Shop<sup>&#174;</sup></span> for Energy Savings</h1>
            </div>
            <div class="start">
                <button (click)="start()" title="Examine your bill for potential savings. This service is free and without obligation.">START</button>
            </div>
        </div>

        <div class="faq-area">
            <h2>FAQ's</h2>
            <ul>
                @for (f of faq(); track f; let i = $index) {
                @if (i>0) {
                <li>
                    <a [class]="(i!=faqOpenQuestion())?'plus-icon':'minus-icon'" style="float: left; margin-left:-30px; width: 20px; height: 20px;" (click)="viewQuestion(i)"></a>
                    <h3 class="link" (click)="viewQuestion(i)">{{f.question}}</h3>
                    <span [class]="(i==faqOpenQuestion())?'visible':'hidden'">{{f.answer}}</span>
                </li>
                }
                }
            </ul>
        </div>
        <div class="text-right"><a routerLink="/faq" class="link">More Questions</a></div>

        <!-- ============================================================
             NEW SECTION — Residential / Commercial rate comparison tabs
             ============================================================ -->
        <div class="charts-tabs-section body" #chartsSection style="margin-top: 30px;">
            <h2 style="margin-bottom: 15px;">Compare Energy Rates</h2>
            <nav mat-tab-nav-bar [tabPanel]="chartTabPanel">
                <a mat-tab-link 
                   [active]="chartTabIndex() === 0"
                   (click)="setChartTab(0)">
                    Residential
                </a>
                <a mat-tab-link 
                   [active]="chartTabIndex() === 1"
                   (click)="setChartTab(1)">
                    Commercial
                </a>
            </nav>
            <mat-tab-nav-panel #chartTabPanel>
                @if (chartTabIndex() === 0) {
                <div class="chart-container price-history owl-theme" style="margin-top: 20px;">
                    @if (residentialRates().length > 0) {
                    <kilowant-charts-home-accept-offer [view]="chartView()"
                                                       [legend]="chartLegend()"
                                                       [legendTitle]="chartLegendTitle()"
                                                       [legendPosition]="chartLegendPosition()"
                                                       [showGridLines]="true"
                                                       [showDataLabel]="false"
                                                       [scheme]="chartColorScheme()"
                                                       [showXAxisLabel]="chartShowXAxisLabel()"
                                                       [showYAxisLabel]="chartShowYAxisLabel()"
                                                       [xAxis]="chartXAxis()"
                                                       [yAxis]="chartYAxis()"
                                                       [xAxisLabel]="chartXAxisLabel()"
                                                       [yAxisLabel]="chartYAxisLabel()"
                                                       [groupPadding]="2"
                                                       [barPadding]="1"
                                                       [valLabel]="''"
                                                       [valColor]="getKilowantColor()"
                                                       [shadow]="true"
                                                       [utilityAverageRate]="0"
                                                       [communityAverageRate]="0"
                                                       [prefix]="'home-res'"
                                                       [results]="residentialPagedRates()"
                                                       [datasetSelector]="false"
                                                       [selectedDatasets]="[1,2]"
                                                       [utilityWarningDate]="''"
                                                       [communityWarningDate]="''"
                                                       [showNormalChatout]="false"
                                                       [hideRenewable]="true"
                                                       [tooltipDisabled]="true"
                                                       [leftShift]="[]"
                                                       [rightShift]="[]"
                                                       [useCommunityAsText]="true"
                                                       >
                    </kilowant-charts-home-accept-offer>

                    <div class="owl-nav">
                        @if (residentialStartRates() != 0) {
                        <div class="owl-prev" (click)="historyContractShiftsLeft('residential')"></div>
                        }
                        @if (residentialStartRates() < residentialRates().length - ratesPerPage) {
                        <div class="owl-next" (click)="historyContractShiftsRight('residential')"></div>
                        }
                    </div>
                    } @else {
                    <div class="loading-chart" style="height: 320px; display: flex; align-items: center; justify-content: center;">
                        Loading rates...
                    </div>
                    }
                </div>
                } @else {
                <div class="chart-container price-history owl-theme" style="margin-top: 20px;">
                    @if (commercialRates().length > 0) {
                    <kilowant-charts-home-accept-offer [view]="chartView()"
                                                       [legend]="chartLegend()"
                                                       [legendTitle]="chartLegendTitle()"
                                                       [legendPosition]="chartLegendPosition()"
                                                       [showGridLines]="true"
                                                       [showDataLabel]="false"
                                                       [scheme]="chartColorScheme()"
                                                       [showXAxisLabel]="chartShowXAxisLabel()"
                                                       [showYAxisLabel]="chartShowYAxisLabel()"
                                                       [xAxis]="chartXAxis()"
                                                       [yAxis]="chartYAxis()"
                                                       [xAxisLabel]="chartXAxisLabel()"
                                                       [yAxisLabel]="chartYAxisLabel()"
                                                       [groupPadding]="2"
                                                       [barPadding]="1"
                                                       [valLabel]="''"
                                                       [valColor]="getKilowantColor()"
                                                       [shadow]="true"
                                                       [utilityAverageRate]="0"
                                                       [communityAverageRate]="0"
                                                       [prefix]="'home-com'"
                                                       [results]="commercialPagedRates()"
                                                       [datasetSelector]="false"
                                                       [selectedDatasets]="[1,2]"
                                                       [utilityWarningDate]="''"
                                                       [communityWarningDate]="''"
                                                       [showNormalChatout]="false"
                                                       [hideRenewable]="true"
                                                       [tooltipDisabled]="true"
                                                       [leftShift]="[]"
                                                       [rightShift]="[]"
                                                       [useCommunityAsText]="true"
                                                       >
                    </kilowant-charts-home-accept-offer>

                    <div class="owl-nav">
                        @if (commercialStartRates() != 0) {
                        <div class="owl-prev" (click)="historyContractShiftsLeft('commercial')"></div>
                        }
                        @if (commercialStartRates() < commercialRates().length - ratesPerPage) {
                        <div class="owl-next" (click)="historyContractShiftsRight('commercial')"></div>
                        }
                    </div>
                    } @else {
                    <div class="loading-chart" style="height: 320px; display: flex; align-items: center; justify-content: center;">
                        Loading rates...
                    </div>
                    }
                </div>
                }
            </mat-tab-nav-panel>
        </div>
        <!-- ============================================================
             END NEW SECTION
             ============================================================ -->

        <div class="tile body round link" style="margin-top: 30px; margin-bottom: 50px;">
            <button class="top-header yellow-button on-home">
                <b>Our Service Territories</b>
            </button>

            <div class="top-info" style="margin-bottom: 0; margin-left: -15px;">
                <div class="utilities-popup">
                    <div class="utility-button utility-ri-energy" (click)="goto('/user/top-offers')"></div>
                    <div class="utility-button utility-nationalgrid"><div class="coming-soon">Coming Soon</div></div>
                    <div class="utility-button utility-eversource"><div class="coming-soon">Coming Soon</div></div>
                </div>
            </div>
            <div class="bottom-tag join">
                <input type="text" name="email" [ngModel]="joinEmail()" (ngModelChange)="joinEmail.set($event)" placeholder="Join our waitlist" /><button type="button" class="bottom-tag joinbtn" (click)="joinWeblistSubmit()">Join</button>
            </div>
        </div>

        <div class="d-flex mt-20 mb-20">
            <div class="auto">
                <bbbseal class="bbbseal bbb_1_61_120"></bbbseal>
            </div>
            <a class="google-rate link" [href]="'https://share.google/ZEgSwLZE8Dsnkr5k9'" target="_blank">
                <div class="google"></div>
                <div class="rate">
                    <span class="star"></span>
                    <span class="star"></span>
                    <span class="star"></span>
                    <span class="star"></span>
                    <span class="star"></span>
                </div>
            </a>
        </div>

    </div>
</div>
<div class="footer-bottom-fixed-full-width no-back" [style]="(!registrationProcess())?'height:0':'height: calc(100dvh - 200px);'">
    <div class="wrapperMain">
        <div class="bottom-selector" style="max-height: none; position: relative;" [class]="(registrationProcess())?'extended':''">
            <div class="register-area">
                <span class="title" style="height: 20px;" (click)="registrationProcess.set(false);">&nbsp;</span>
                @if (!errorY().showError()) {
                <div class="text" style="margin: auto; height: 100px;">
                    <div>Please upload an image or photo of your RI Energy Electricity Bill Page 1. Your information will be used for quotation purposes only.</div>
                </div>
                }
                <div class="image" #basicArea>
                    <div style="height: 100%; display: table; width: 100%;">
                        <div style="width: 100%; height: 100%; vertical-align: middle; display: table-cell;">
                            @if (!errorY().showError()) {
                            <div class="bill-photo-home" style="height: 90%; max-height: 500px; width: 100%"></div>
                            }
                            @if (errorY().showError() && !loading() && !progress() && errorY().error.substring(0,20)=='notrightutilityissue') {
                            <div class="error-block">The utility bill uploaded is not recognized as a Rhode Island Energy account. Please upload a qualifying Rhode Island Energy bill or join our waitlist below and we'll notify you when kilowant is active in your utility service territory.</div>
                            <div class="tile body round link" style="margin-top: 30px; margin-bottom: 50px;">
                                <button class="top-header yellow-button on-home">
                                    <b>Our Service Territories</b>
                                </button>

                                <div class="top-info" style="margin-bottom: 0; margin-left: -15px;">
                                    <div class="utilities-popup">
                                        <div class="utility-button utility-ri-energy" (click)="goto('/user/top-offers')"></div>
                                        <div class="utility-button utility-nationalgrid"><div class="coming-soon">Coming Soon</div></div>
                                        <div class="utility-button utility-eversource"><div class="coming-soon">Coming Soon</div></div>
                                    </div>
                                </div>
                                <div class="bottom-tag join">
                                    <input type="text" name="email" [ngModel]="joinEmail()" (ngModelChange)="joinEmail.set($event)" placeholder="Join our waitlist" /><button type="button" class="bottom-tag joinbtn" (click)="joinWeblistSubmit()">Join</button>
                                </div>
                            </div>

                            }
                            @if (errorY().showError() && !loading() && !progress() && errorY().error.substring(0,12)=='accountissue') {
                            <div class="error-block">The account number you entered is already in use. Please verify the number and try again. If you believe that your account number has been used without your authorization, please <a (click)="reportAccountIssue(errorY().error.substring(13))">click here</a> to report it to kilowant for investigation.</div>
                            }
                            @if (errorY().showError() && !loading() && !progress() && errorY().error.substring(0,12)!='accountissue'  && errorY().error.substring(0,20)!='notrightutilityissue') {
                            <div class="error-block">{{errorY().error}}</div>
                            }
                        </div>
                    </div>
                </div>
                <div class="select-utility">
                    @if (!loading() && !progress()) {
                    <div class="progress-tabs" style="margin-top: 0">
                        <label class="i_upload link" [class]="(imageMode()==0)?'current':''"><br />Upload<input style="display: none;" type="file" name="billImage" class="required" value="" placeholder="Bill Image" (change)="handleFileInput($event)" /></label>
                        <label class="i_camera link" [class]="(imageMode()==2)?'current':''"><br />Photo<input type="file" capture="camera" accept="image/*" name="billImage" style="display: none;" value="" placeholder="Bill Image File" (change)="handleFileInput($event)" /></label>
                    </div>
                    }
                    @if (loading() || progress()) {
                    <div class="progress-bar">
                        Account Creation in Progress
                        <div class="bar">
                            <span class="progress" [style]="'width: '+progressWidth()+'%'"></span>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>